/*
 * 项目全部的数据请求方法，方便统一管理
 * 需要引入fetch (请求方法)，api (请求地址)
 */

import { fetch } from '../http/http';               // 引入请求方法
import api from '../api/api';                       // 引入请求地址

// 监区列表
export const prisonLists = (data) => fetch('POST', api.prisonLists, data);
// 服刑人员登陆
export const findLogin = (data) => fetch('POST', api.findLogin, data);files
// 文件上传
export const files = (data) => fetch('POST', api.files, data);
// 文件下载
export const filesDown = (data) => fetch('GET', api.filesDown, data);
// 字典
export const zd = (data) => fetch('POST', api.zd, data);
//familyInfo
export const familyInfo = (data) => fetch('GET', api.familyInfo, data);
export const getToken = (data) => fetch('GET', api.getToken, data);





// WEBPACK FOOTER //
// ./src/axios/request/request.js